import { useEffect, useState } from "react";
import { Plus, Clapperboard } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CharacterCard } from "./CharacterCard";
import { ImportCast } from "./ImportCast";

export const CastTab = ({ ep, chars, reload, setTab }) => {
  const [voices, setVoices] = useState([]);
  const [name, setName] = useState("");
  useEffect(() => { http.get("/voices").then((r) => setVoices(r.data)); }, []);
  const add = async () => {
    if (!name.trim()) return;
    try { await http.post(`/episodes/${ep.id}/characters`, { name: name.trim() }); setName(""); await reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const locked = chars.filter((c) => c.looks_locked && c.voice_locked).length;

  return (
    <div data-testid="cast-tab">
      <div className="flex flex-wrap items-end gap-4 mb-6">
        <div>
          <h2 className="text-xl lg:text-2xl font-semibold">Character sheet</h2>
          <p className="text-sm text-slate-400 mt-1">Generate each look and voice, then lock both. Locked references go into every clip.</p>
        </div>
        <span className="font-mono text-xs text-amber-400" data-testid="cast-locked-count">{locked}/{chars.length} FULLY LOCKED</span>
        <div className="ml-auto flex gap-2">
          <Input data-testid="new-character-name" placeholder="Add character name" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} className="w-48" />
          <Button data-testid="add-character-btn" variant="secondary" onClick={add} className="rounded-full"><Plus className="w-4 h-4" /></Button>
          <ImportCast ep={ep} reload={reload} />
          <Button data-testid="go-to-studio-btn" onClick={() => setTab("studio")} className="rounded-full"><Clapperboard className="w-4 h-4 mr-2" />Studio</Button>
        </div>
      </div>
      {chars.length === 0 && (
        <div className="panel p-8 text-sm text-slate-400" data-testid="cast-empty">
          Characters are detected automatically when you split the script. You can also add them by name.
        </div>
      )}
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-5">
        {chars.map((c) => <CharacterCard key={c.id} c={c} voices={voices} reload={reload} />)}
      </div>
    </div>
  );
};
